<template>
    <div class="container">
        <div class="mt-5 mb-2 fl-te-c card">
            <btn text="<-" class="" @click="$router.go(-1)" size="sm"/>
            <h4 class="text-primary mb-0 font-poppins-semibold">INTERVIEW</h4>
            <div>
                <btn size="sm" text="ADD" icon="fa fa-plus"
                     @click="$refs.addInterview.show();"></btn>
            </div>
        </div>
        <div class="card mt-2">
            <div class="row m-0">
                <div class="col-12">
                    <vue-table ref="table" :fields="fields" :url="listURL" :per-page="50">
                        <template slot="actions" slot-scope="props">
                            <div class="btn-group">
                                <btn text="" size="sm" icon="fa fa-pencil" color="primary"
                                     @click="editItem(props.rowData)"/>
                                <btn text="" size="sm" icon="fa fa-eye" color="primary"
                                     @click="showDetails(props.rowData)"/>
                                <btn text="" size="sm" icon="fa fa-trash" color="danger"
                                     @click="deleteItem(props.rowData.id)"/>
                            </div>

                        </template>
                    </vue-table>

                </div>

            </div>
        </div>

        <modal ref="addInterview" :no-close-on-backdrop="true" title="Interview" width="40r" header-color="primary" :show-additional-buttons="true">
            <template #buttons>
                <a @click="addClose"><i class="fa fa-close"></i></a>
            </template>
            <s-form @submit="addEditItem">
                <div class="row">
                    <div class="col-lg-6">
                        <validated-input label="Title" :rules="{required: true}"
                                         class="field-required" border-radius="1" v-model="model.title "></validated-input>
                    </div>
<!--                    <div class="col-lg-6">-->
<!--                        <validated-ajax-vue-select class="c-input-select field-required" :rules="{required: true}"-->
<!--                                               :url="interviewTypeOptionsURL"-->
<!--                                               label="Interview Type" v-model="model.interview_type"></validated-ajax-vue-select>-->
<!--                    </div>-->

<!--                    <div class="col-lg-6">-->
<!--                        <validated-ajax-vue-select multiple label="Interview Topics" :rules="{required: true}" :url="interviewTopicOptionsURL"-->
<!--                                         class="field-required" border-radius="1" v-model="model.interview_topics "/>-->
<!--                    </div>-->
<!--                    <div class="col-lg-6">-->
<!--                        <validated-ajax-vue-select class="c-input-select field-required" :rules="{required: true}"-->
<!--                                               :url="skillOptionsURL"-->
<!--                                               label="Skills" v-model="model.skill"></validated-ajax-vue-select>-->
<!--                    </div>-->
<!--                    <div class="col-lg-6">-->
<!--                        <validated-input label="No of Questions" :rules="{required: true}"-->
<!--                                         class="field-required" border-radius="1" v-model="model.no_of_questions "></validated-input>-->
<!--                    </div>-->
<!--                    <div class="col-lg-6">-->
<!--                        <validated-input label="Time Allotted in Minutes" :rules="{required: true}"-->
<!--                                         class="" border-radius="1" v-model="model.time_allotted "></validated-input>-->
<!--                    </div>-->
                    <div class="col-12 text-right mt-4">
                        <btn text="Save" :loading="addLoading" loading-text="Saving..." class="px-4"></btn>
                    </div>
                </div>
            </s-form>
        </modal>
        <modal ref="editInterview" :no-close-on-backdrop="true" title="Interview" width="40r" header-color="primary">
            <s-form @submit="addEditItem">
                <div class="row">
                    <div class="col-lg-6">
                        <validated-input label="Title" :rules="{required: true}"
                                         class="field-required" border-radius="1" v-model="editingItem.title "></validated-input>
                    </div>
<!--                    <div class="col-lg-6">-->
<!--                        <validated-ajax-vue-select class="c-input-select field-required" :rules="{required: true}"-->
<!--                                               :url="interviewTypeOptionsURL"-->
<!--                       label="Interview Type" v-model="editingItem.interview_type "/>-->
<!--                    </div>-->
<!--                    <div class="col-lg-6">-->
<!--                        <validated-ajax-vue-select multiple class="c-input-select field-required" :rules="{required: true}"-->
<!--                                               :url="interviewTopicOptionsURL"-->
<!--                       label="Interview Topic" v-model="editingItem.interview_topics "/>-->
<!--                    </div>-->
<!--                    <div class="col-lg-6">-->
<!--                        <validated-ajax-vue-select class="c-input-select field-required" :rules="{required: true}"-->
<!--                                               :url="skillOptionsURL"-->
<!--                       label="Skill" v-model="editingItem.skill "/>-->
<!--                    </div>-->
<!--                    <div class="col-lg-6">-->
<!--                        <validated-input label="No of Questions" :rules="{required: true}"-->
<!--                                         class="field-required" border-radius="1" v-model="editingItem.no_of_questions "></validated-input>-->
<!--                    </div>-->
<!--                    <div class="col-lg-6">-->
<!--                        <validated-input label="Time Allotted"-->
<!--                                         class="" border-radius="1" v-model="editingItem.time_allotted "></validated-input>-->
<!--                    </div>-->
                    <div class="col-12 text-right mt-2">
                        <div class="btn-group">
<!--                            <btn text="Generate" @click="GenerateQuestions" :loading="editLoading" loading-text="Generating Questions..." class="px-4"></btn>-->
                            <btn text="Save" :loading="editLoading" loading-text="Saving..." class="px-4"></btn>
                        </div>
                        </div>

                </div>
            </s-form>
        </modal>

        <delete-modal ref="deleteModal" enter-animation="animated slideInDown" exit-animation="animated slideOutUp" :url="deleteURL" :params="{id : itemID}"
                      @response="deleteComplete">
            <p> Are you sure ?</p>
            <template #loading>
                <div class="fl-x">
                    <loading-animation/>
                    <b class="ml-3">Please Wait...</b>
                </div>
            </template>
        </delete-modal>

    </div>

</template>

<script>
import axios from 'secure-axios';
import urls from '../../../data/urls';

export default {
    name: 'Interview',
    data () {
        return {
            addEditURL: urls.mcq_interview.interview.addEdit,
            listURL: urls.mcq_interview.interview.list,
            deleteURL: urls.mcq_interview.interview.delete,
            // interviewTypeOptionsURL: urls.mcq_interview.interview_type.select,
            skillOptionsURL: urls.mcq_interview.skill.select,
            // interviewTopicOptionsURL: urls.mcq_interview.interview_topic.select,
            itemID: null,
            addLoading: false,
            editLoading: false,
            editStatus: false,
            editingItem: {
                id: null,
                title: null,
                // interview_type: null,
                // interview_topics: null,
                // no_of_questions: null,
                time_allotted: null
            },
            model: {
                name: null
            },
            fields: [
                {
                    name: 'title',
                    sortField: 'title',
                    title: 'Title'
                },
                // {
                //     name: 'interview_type_name',
                //     sortField: 'interview_type_name',
                //     title: 'Interview Type'
                // },
                // {
                //     name: 'skill_name',
                //     sortField: 'skill_name',
                //     title: 'Skill'
                // },
                // {
                //     name: 'interview_topic_names',
                //     sortField: 'interview_topic_names',
                //     title: 'Interview Topics'
                // },
                // {
                //     name: 'no_of_questions',
                //     sortField: 'no_of_questions',
                //     title: 'No of Questions'
                // },
                {
                    name: '__slot:actions',
                    title: 'Actions'
                }
            ]
        };
    },
    methods: {
        // GenerateQuestions () {
        //     this.$router.push({ path: '/general/' });
        // },
        async addEditItem () {
            try {
                if (this.editStatus) {
                    this.editLoading = true;
                } else {
                    this.addLoading = true;
                }
                const response = await axios.form(this.addEditURL, this.editStatus ? this.editingItem : this.model);
                const result = response.data;
                if (result.success) {
                    if (this.editStatus) {
                        this.$notify(' Interview Edited Successfully', 'Success', { type: 'success' });
                        this.editLoading = false;
                        this.editFormSuccess();
                    } else {
                        this.$notify('Interview Added Successfully', 'Success', { type: 'success' });
                        this.addLoading = false;
                        this.addFormSuccess();
                    }
                } else {
                    const errors = response.data.errors;

                    for (const key in errors) {
                        if (Object.prototype.hasOwnProperty.call(errors, key)) {
                            let errorMessage = '';
                            if (key === '__all__') {
                                errorMessage = `${errors[key]}`;
                            } else {
                                errorMessage = `${key}:  ${errors[key]}`;
                            }
                            this.$notify(errorMessage, 'Warning', { type: 'warning' });
                        }
                    }
                    this.editLoading = false;
                    this.addLoading = false;
                }
            } catch (error) {
                this.$notify(
                    'Something Went Wrong..!!',
                    error.response.status + ' ' + error.response.statusText,
                    { type: 'danger' }
                );
                this.editLoading = false;
                this.addLoading = false;
            }
        },
        addFormSuccess () {
            this.$refs.addInterview.close();
            this.model.title = null;
            // this.model.interview_type = null;
            this.model.skill = null;
            // this.model.interview_topics = null;
            // this.model.no_of_questions = null;
            this.model.time_allotted = null;
            this.$refs.table.refreshTable();
        },
        editFormSuccess () {
            this.editStatus = false;
            this.$refs.editInterview.close();
            this.$refs.table.refreshTable();
        },
        editItem (item) {
            console.log('edit-item:>>>:', item);
            this.editStatus = true;
            this.editingItem.id = item.id;
            this.editingItem.title = item.title;
            this.editingItem.skill = item.skill;
            // this.editingItem.interview_type = item.interview_type;
            // this.editingItem.interview_topics = item.interview_topics;
            // this.editingItem.no_of_questions = item.no_of_questions;
            this.editingItem.time_allotted = item.time_allotted;
            this.$refs.editInterview.show();
        },
        showDetails (item) {
            this.$router.push('/mcq-interview/' + item.id + '/interview-details/');
        },
        deleteItem (item) {
            this.itemID = item;
            this.$refs.deleteModal.show();
        },
        deleteComplete () {
            this.$refs.table.refreshTable();
            this.$notify('Deleted Successfully', 'Success', {
                type: 'success'
            });
            this.$refs.deleteModal.close();
        },
        addClose () {
            this.model.title = '';
            // this.model.interview_type = null;
            // this.model.interview_topics = null;
            this.model.skill = null;
            // this.model.no_of_questions = null;
            this.model.time_allotted = null;
            this.$refs.addInterview.close();
        }
    }
};
</script>

<style scoped>

</style>
